<script setup lang="ts">
import { useI18n } from "vue-i18n"

import { TERMS_OF_SERVICE } from "@/pages"

const { t } = useI18n({ useScope: "global" })
</script>

<template>
  <RouterLink id="termsofuselink-link-termsofuse" :to="{ name: 'DocumentGet', params: { id: TERMS_OF_SERVICE } }" class="link" :title="t('footer.termsOfUse')">{{
    t("footer.termsOfUseShort")
  }}</RouterLink>
</template>
